import React, {useEffect, useState} from 'react';
import AllTicketsHeader from "../AllTickets/AllTicketsHeader";
import SideBar from "../SideBar/SideBar";
import axiosApiInstance from "../axios";
import DataTable from "react-data-table-component";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert, AlertTitle, LinearProgress } from "@mui/material";
import Checkbox from "@material-ui/core/Checkbox";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { red } from '@mui/material/colors';
import CAlertBox from '../CAlertBox/CAlertBox';
import { Save } from '@material-ui/icons';

const Status = () => {
  const [Status, setStatus] = useState([]);
  const [StatusSearch, setStatusSearch] = useState([]);
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [openDeleteMssg, setOpenDeleteMssg] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const[isActive, setIsActive] =useState("");
   const [checked, setChecked] = useState(true);

  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [idEdit, setIdEdit] = useState([]);
  const [editName, setEditName] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editIsActive, setEditIsActive]=useState("");
  const [openUpdateMssg, setOpenUpdateMssg] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [errMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    axiosApiInstance
      .get("/status")
      .then((res) => {
        setStatus(res.data.data);
        setStatusSearch(res.data.data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, [open, isDelete, isOpenEdit]);
 

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      width: "70px",
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      justifyContent: 'end',
    },
    {
        name: "Description",
        selector: (row) =>   row.description = row.description
       

    },
    
    {
      
      name: "Action",
      cell: (row) => (
        <>
          <ModeEditIcon onClick={() => handleEditClick(row)} />
          <p className="seperation-field">  </p>
          <DeleteOutlineIcon onClick={() => handleDeleteClick(row.id)} />
        </>
      ),
      tesxtAlign: 'end',
      
    },
  ];
  useEffect(() => {
    const result = Status.filter((catg) => {
      return catg?.name?.toLowerCase().match(searchTerm.toLowerCase());
    });
    setStatusSearch(result);
  }, [searchTerm]);
  
  const handleDeleteClick = (id) => {
    setId(id);
    setIsDelete(true);
  };

  const handleClickOpen = () => {
    setName('');
    setDescription('');
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setErrorMessage(''); 
  };

  const handleDeleteClose = () => {
    setIsDelete(false);
  };

  const handleEditClick = (id) => {
    setIdEdit(id);
    setEditName(id.name);
    setEditDescription(id.description);

       setIsOpenEdit(true);
  };

  const handleEditClose = () => {
    setIsOpenEdit(false);
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (name === "" || description === "") {
      setErrorMessage("Please enter missing field");
      return; // Return early to prevent further execution
  }
    let data = {
      name: name,
      description: description,    
    };
    
    axiosApiInstance.post("/status", JSON.stringify(data)).then((res) => {
      if (res.data.succeeded) {
        setOpen(false);
        setIsOpen(true);
      } else {
        setOpen(false);
        setTimeout(() => {
          setAlertMessage(res.data.message && res.data.message);
        }, 500);
      }
    });
  };

   
  useEffect(() => {
    setTimeout(() => {
      setOpenUpdateMssg(false);
    }, 3000);
  }, []);     
    

  
  const handleUpdate = (e) => {
    e.preventDefault();
    let data = {
      id : idEdit.id,
      name: editName === "" ? idEdit.name : editName,
      description: editDescription === "" ? idEdit.description : editDescription,
      isActive: checked ? true : true,
    };
    axiosApiInstance.patch("/status", JSON.stringify(data)).then((res) => {
      if (res.data.succeeded==true) {
        setIsOpenEdit(false);
        setOpenUpdateMssg(true);
      } else {
        setIsOpenEdit(false);
        setTimeout(() => {
          setAlertMessage(res.data.message && res.data.message);
        }, 500);
      }
    });
  
   
  };
  

  const handleDelete = () => {
    axiosApiInstance
      .delete(`/status/${id}`)
      .then((res) => {
        if (res?.data?.succeeded === true) {
          setStatus(Status.filter((x) => x.id !== id));
          setIsDelete(false);
          setOpenDeleteMssg(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

    
  return (
    <>
      <AllTicketsHeader 
        searchKeyword={searchHandler}
        term={searchTerm}
    
      />
      <SideBar />
      <div className="category-container">
        <div className="add-category">
          <Button onClick={handleClickOpen}>
            <span>+</span>ADD
          </Button>
        </div>
        <Box sx={{ width: "100%" }}>
          <Collapse in={isOpen}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              New Status added successfully!
            </Alert>
          </Collapse>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Collapse in={openDeleteMssg}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="info"
                  size="small"
                  onClick={() => {
                    setOpenDeleteMssg(false);
                  }}
                >
                  <CloseIcon fontSize="info" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              Deleted successfully!
            </Alert>
          </Collapse>
        </Box>


        <Box sx={{ width: "100%" }}>
          <Collapse in={openUpdateMssg}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="info"
                  size="small"
                  onClick={() => {
                    setOpenUpdateMssg(false);
                  }}
                >
                  <CloseIcon fontSize="info" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              Updated successfully!
            </Alert>
          </Collapse>
        </Box>



        {loading ? (
          <LinearProgress />
        ) : (
          <>
            <DataTable
              columns={columns}
              data={StatusSearch}
              selectableRowsHighlight
              highlightOnHover
              pagination
              pointerOnHover
              paginationPerPage={6}
            />
          </>
        )}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle className="category-title">
            Create New Status
          </DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                required
                id="outlined-required"
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
               <TextField
                required
                id="outlined-textarea"
                label="Description"
                multiline
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <Box sx={{ paddingLeft: "10px" }}> {errMessage && (
                  <label style={{ color: "red" }}>{errMessage}</label>
                )}</Box>
            
            </Box>
          </DialogContent>
          <DialogActions>
            <Button className="save-category" onClick={handleSave}>
              Save
            </Button>
            <Button className="close-category" onClick={handleClose}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isDelete}
          onClose={handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          
          <DialogTitle id="alert-dialog-title">
         
            Are you sure you want to delete ? 
            
           
          </DialogTitle>
          <DialogActions>
            <Button className="save-category" onClick={handleDelete}>
              DELETE
            </Button>
            <Button className="close-category" onClick={handleDeleteClose}>
              CANCEL
            </Button>
          </DialogActions>
         
        </Dialog>

        <Dialog
          open={isOpenEdit}
          onClose={handleEditClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle className="category-title">Update Status</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
               
                id="outlined-required"
                label="Name"
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
              />
              <TextField
  
               id="outlined-required"
               label="Description"
               multiline
               value={editDescription}
               onChange={(e) => setEditDescription(e.target.value)}
             />
              
              
            </Box>
          </DialogContent>
          <DialogActions>
            <Button type='submit' className="save-category" onClick={handleUpdate}>
              SAVE
            </Button>
            <Button className="close-category" onClick={handleEditClose}>
              CANCEL
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />
    </>
  );
 
}

export default Status